export const formatZendeskCallTranscript = (
  markdown: string,
  guestName?: string,
  agentName = 'AvantStay',
) => {
  const lineRegex = /^\*\*(\d{2}:\d{2})\*\*(?:\s+\*\*([^*]+?)\*\*)?\s+(.+)$/gm

  const normalizedMarkdown = markdown.replace(/\\n/g, '\n')
  const cleanedMarkdown = normalizedMarkdown
    .replace(/^#+\s*\*\*Call transcript:?\*\*.*$/im, '')
    .replace(/^\* \* \*.*$/gm, '')
    .replace(/_If you redact any data[\s\S]*/i, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim()

  const formatted: string[] = []
  let match: RegExpExecArray | null

  while ((match = lineRegex.exec(cleanedMarkdown)) !== null) {
    const timestamp = match[1]
    let speaker = match[2]
    const message = match[3].replace(/\s+/g, ' ').trim()

    if (speaker === 'Agent' && agentName) {
      speaker = agentName
    } else if (speaker && guestName) {
      speaker = guestName
    }

    formatted.push(
      `<br /> - **timestamp:** ${timestamp}` +
        (speaker ? ` <br /> - **speaker:** ${speaker}` : '') +
        ` <br /> - **message:** ${message}`,
    )
  }

  if (formatted.length === 0) {
    return 'No transcript available for this call.'
  }

  return formatted.join(' ')
}
